module.exports = __webpack_public_path__ + "static/banner-mobile-8523ad4bedd4697082c08b72fd07fd15.png";